import { gql } from "@apollo/client";
import { InvoiceReviewStatus } from "common/graphql/fragments/invoiceFragment";

export const REVIEW_INVOICE = gql`
  mutation ReviewInvoice($invoiceId: uuid!, $approve: Boolean!) {
    review_invoice(invoice_id: $invoiceId, approve: $approve) {
      invoice_id
      review_status
      voided_at
      updated_at
    }
  }
`;

export interface ReviewInvoiceOutput {
  invoice_id: string;
  review_status: InvoiceReviewStatus;
  voided_at: string | null;
  updated_at: string;
}

export interface ReviewInvoiceData {
  review_invoice: ReviewInvoiceOutput;
}

export type ReviewInvoiceVars = ApproveInvoiceVars | DenyInvoiceVars;

export interface ApproveInvoiceVars {
  invoiceId: string;
  approve: true;
}

export interface DenyInvoiceVars {
  invoiceId: string;
  approve: false;
}
